/**
 * CajaChargeAuthSettings — Toggle único: exigir identificación al cobrar.
 */
import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { useAuthStore } from "@/store/authStore";
import { SwitchRow } from "@/components/ui/Switch";
import {
  loadCashDrawerSecurityConfig,
  normalizeCashDrawerSecurity,
  persistCashDrawerSecurityConfig,
} from "@/features/caja/lib/cashDrawerSecurityConfig";

export function CajaChargeAuthSettings() {
  const businessId = useAuthStore((s) => s.user?.businessId);
  const [hydrated, setHydrated] = useState(false);
  const [requireId, setRequireId] = useState(true);

  useEffect(() => {
    setHydrated(false);
    const c = normalizeCashDrawerSecurity(
      loadCashDrawerSecurityConfig(businessId),
    );
    setRequireId(c.requireIdentificationOnCharge !== false);
    setHydrated(true);
  }, [businessId]);

  useEffect(() => {
    const onExternal = () => {
      const c = normalizeCashDrawerSecurity(
        loadCashDrawerSecurityConfig(businessId),
      );
      setRequireId(c.requireIdentificationOnCharge !== false);
    };
    window.addEventListener("altenot:cash-drawer-security", onExternal);
    return () =>
      window.removeEventListener("altenot:cash-drawer-security", onExternal);
  }, [businessId]);

  useEffect(() => {
    if (!hydrated) return;
    const id = window.setTimeout(() => {
      const full = normalizeCashDrawerSecurity(
        loadCashDrawerSecurityConfig(businessId),
      );
      const next = normalizeCashDrawerSecurity({
        ...full,
        requireIdentificationOnCharge: requireId,
      });
      const prev = normalizeCashDrawerSecurity(
        loadCashDrawerSecurityConfig(businessId),
      );
      if (JSON.stringify(prev) === JSON.stringify(next)) return;
      persistCashDrawerSecurityConfig(businessId, next);
    }, 420);
    return () => window.clearTimeout(id);
  }, [businessId, hydrated, requireId]);

  return (
    <SwitchRow
      size="sm"
      icon={
        <ShieldCheck size={16} className="text-slate-600 dark:text-slate-300" />
      }
      label="Exigir identificación al cobrar"
      description={
        requireId
          ? "Cada COBRAR pide carnet (pistola) o la contraseña de login del cajero."
          : "Cobra quien inició sesión en la tablet, sin pedir carnet ni contraseña."
      }
      checked={requireId}
      onChange={setRequireId}
    />
  );
}
